import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer
} from "@mui/material";

export default function ReportTable({ columns, rows }) {

  const safeRows = Array.isArray(rows) ? rows : [];

  return (
    <TableContainer component={Paper} sx={{ marginTop: 3 }}>
      <Table>

        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={col.field}>
                <b>{col.header}</b>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {safeRows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} align="center">
                No data found
              </TableCell>
            </TableRow>
          ) : (
            safeRows.map((row, i) => (
              <TableRow key={i}>
                {columns.map((col) => (
                  <TableCell key={col.field}>
                    {row[col.field]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>

      </Table>
    </TableContainer>
  );
}